<template>
    <div class="container-fluid pt-4">
        <div class="d-flex flex-row flex-wrap">

            <div class="col-md-3 pointer mb-3" v-for="product in products" v-if="products.length > 0">
                <div class="productImageArea text-center lightest pt-3" :style="{'background-image': 'url('+product.imageLogo+')'}" @click="checkAvailability(product)">
                    <div class="fs-smaller">{{productCategories(product)}}</div>
                    <div class="fs-largest mt-3 pt-4 px-3">{{product.name}}</div>

                    <div class="checkAvailability bg-color-6 py-2 radius-normal">
                        Check Availability
                    </div>

                </div>

                <!-- <div class="darker bg-lightest text-center p-2 fs-small underlined">
                    view details
                </div> -->


            </div>


            <div class="col-sm-12 dark fs-large font-weight-600 text-center mt-4" v-if="products.length == 0">
                No products found, you can create them <router-link class="darker":to="{ name: 'pluralo.product.new'}">here</router-link>.
            </div>


        </div>
    </div>
</template>

<script>
export default{
    data: function() {
        return{

        }
    },
    props:{
        products:{
            type: Array,
            default: []
        }
    },
    methods: {
        checkAvailability: function(product) {
            this.$emit('checkAvailability', product)
        },
        productCategories: function (item) {
            return (item.categoryList.length > 0) ? item.categoryList.map(i => i.name).join(', ') : '-'
        }
    },
    components: {
    }
}
</script>

<style lang="scss">
    .productImageArea{
        position: relative;
        background-size: cover;
        background-position: center;
        height: 180px;

        &:before {
            content: '';
        	position: absolute;
        	top: 0;
        	right: 0;
        	bottom: 0;
        	left: 0;
        	background-image: linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,1));
        	opacity: .4;
            z-index: 1
        }

        *{
            position: relative;
            z-index: 2
        }

        .checkAvailability{
            opacity: 0;
            position: absolute;
            bottom: 10px;
            width: 90%;
            left: 5%;
            transition: all 200ms ease-in-out;
        }
    }

    .productImageArea:hover{

        .checkAvailability{
            opacity: 1;
        }
    }
</style>



// WEBPACK FOOTER //
// ProductList.vue?03341f6b